/*
 * @Author: Wang Wenmao
 * @Date: 2023-12-01 18:07:48
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2024-01-10 18:48:17
 * @Description: 优惠券列表
 */
import React, { PureComponent } from 'react';
import { map, cloneDeep } from 'lodash';
import { Tag } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { services } from '@comall-backend-builder/core';
import { utils } from '../../../services';
const api = services.api;

interface IProps {
    onChange: (value: any) => void;
}

export class ShowCoupons extends PureComponent<IProps> {
    state = { couponData: [] };

    componentDidMount(): void {
        this.getData();
    }

    getData = () => {
        const { onChange } = this.props;
        api.get({}, { apiPath: '/coupons/point', customHeaders: { Apiversion: '2.0' } }).then(
            (res: any) => {
                const couponData = res.coupons;
                this.setState({ couponData }, () => onChange(couponData));
            }
        );
    };

    onDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }
        const { couponData } = this.state;
        const { onChange } = this.props;
        const startIndex = result.source.index;
        const endIndex = result.destination.index;

        let newData = cloneDeep(couponData);
        const [removed] = newData.splice(startIndex, 1);
        newData.splice(endIndex, 0, removed);

        this.setState({ couponData: newData }, () => onChange(newData));
    };

    render() {
        const { couponData } = this.state;
        const isDragDropDisabled = couponData.length === 1;
        return (
            <div className="show-coupons">
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable isDropDisabled={isDragDropDisabled} droppableId="product-list">
                        {(provided: any) => (
                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                {map(couponData, (item: any, index: number) => (
                                    <Draggable
                                        isDragDisabled={isDragDropDisabled}
                                        draggableId={'product-' + index}
                                        key={index}
                                        index={index}
                                    >
                                        {(provided: any) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <Tag
                                                    key={item.couponDefinitionCode}
                                                    className="product-i"
                                                >
                                                    <p style={{ fontSize: '13px', height: '15px' }}>
                                                        优惠券名称: {item.couponName}
                                                    </p>
                                                </Tag>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        );
    }
}
